module.exports = __webpack_public_path__ + "static/media/nk-login-small-bg.fe8f5667.jpg";